import { ContentManagerSummaryDTO, MetricsService } from '@activia/cm-api';
import { Injectable } from '@angular/core';
import { TimerService } from '@amp/messenger';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { ErrorHandlingService } from '@amp/error';
import { catchError, map, shareReplay, switchMap, takeWhile } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ContentOverviewService {
  public static refreshDelay: number = 1000 * 30 * 60; // 30 minutes

  private _subscriberCount = new BehaviorSubject(0);
  private _timer$: Observable<number>;

  constructor(private statsService: MetricsService, private errorHandlingService: ErrorHandlingService, private timerService: TimerService) {}

  start() {
    this._subscriberCount.next(this._subscriberCount.value + 1);
  }

  stop() {
    const subscribers = this._subscriberCount.value - 1;
    this._subscriberCount.next(subscribers);
    if (subscribers < 1) {
      this._timer$ = undefined;
    }
  }

  startTimer() {
    this._timer$ = this.timerService.timer$(ContentOverviewService.refreshDelay).pipe(
      takeWhile(() => this._subscriberCount.value > 0),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  getContentOverview(): Observable<ContentManagerSummaryDTO> {
    if (this._timer$ == null) {
      this.startTimer();
    }

    return this._timer$.pipe(
      switchMap(() => this.statsService.getContentManagerSummary().pipe(
          map((overview) => overview),
          catchError((err: HttpErrorResponse) => {
            if (err.status !== 0) {
              this.errorHandlingService.catchError(err, undefined, 'global.error.fetch-content-manager-summary-fail');
            }
            this._subscriberCount.next(0);
            return EMPTY;
          })
        )),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }
}
